module.exports = __webpack_public_path__ + "static/media/stripe-onboarding_4.6875bb32.png";